// extracted by mini-css-extract-plugin
export default {"textarea":"styles_textarea__eCnTI","textareaLabel":"styles_textareaLabel__rfdAR","textareaLabelText":"styles_textareaLabelText__HqaBK","textareaField":"styles_textareaField__EOTyz"};